import Icon from '../components/Icon.vue'

Icon.register({
  dog: {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M496 96c8.8 0 16 7.2 16 16v32c0 35.3-28.7 64-64 64h-32v35.6l-128-45.7v-149.8c0-14.3 17.2-21.4 27.3-11.3l27.3 27.3h53.6c10.9 0 23.7 7.9 28.6 17.7l7.2 14.3h64zM384 144c8.8 0 16-7.2 16-16s-7.2-16-16-16-16 7.2-16 16 7.2 16 16 16zM96 224h170.1l149.9 53.5v218.4c0 8.8-7.2 16-16 16h-64c-8.8 0-16-7.2-16-16v-112h-160v112c0 8.8-7.2 16-16 16h-64c-8.8 0-16-7.2-16-16v-213.9c-37.2-13.3-64-48.4-64-90.1 0-17.7 14.3-32 32-32s32 14.3 32 32c0 17.6 14.4 32 32 32z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/dog.js
// module id = 1272
// module chunks = 0